<template>
<div>
  <el-dialog append-to-body :title="title" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" :width="win.w" :top="top">

    <div class="view-file-win">
      <iframe v-if="src" :src="src" class="view-file" :style="{height:win.h}" @loadstart="loadstart" @loadeddata="loadeddata"></iframe>
<!--      <div  class="view-file-loading"></div>-->
    </div>
    <template slot="footer">
      <div>
        <el-button @click="openViewFile">全屏预览</el-button>
        <el-button icon="el-icon-download" type="primary" @click="downFile" :loading="down_loading">下 载</el-button>
        <el-button icon="el-icon-close" type="warning" @click="onClose">关 闭</el-button>
      </div>
    </template>
  </el-dialog>
</div>
</template>

<script>
import CryptoJS from "crypto-js";
import AppConfig from "../../../config/AppConfig";
export default {
  name: "ViewFile",
  data(){
    return {
      dialogVisible:false,
      win:{
        h:"600px",
        w:"800px",
      },
      title:"",
      top:"",
      src:"",
      _src:"",
      load_win:null,
      _download:null,
      _fileinfo:null,
      bucket:"",
      duration_time:86400,
      down_loading:false,
    }
  },
  methods:{
    show({title="",width="800px",height="600px",src,bucket="gdza",duration_time=86400,download}){
      this.dialogVisible=true;
      this.win.w=width;
      this.win.h=height;
      // this.bucket=bucket;
      // this.duration_time=duration_time;
      // this.src='https://view.officeapps.live.com/op/view.aspx?src='+window.encodeURIComponent(src)
      // this.src='https://view.xdocin.com/xdoc?_xdoc='+window.encodeURIComponent(src)
      this._src=src;
      let wordArray = CryptoJS.enc.Utf8.parse(src);
      let word=CryptoJS.enc.Base64.stringify(wordArray);
      //'http://api.gdzawy.com:9013/onlinePreviewObject?url='+encodeURIComponent(word)+'&bucket='+bucket+'&duration_time='+duration_time
      this.src=AppConfig.os_server+'onlinePreviewObject?url='+encodeURIComponent(word)+'&bucket='+bucket+'&duration_time='+duration_time
      this._download=download;
      this.top=` calc( ( 100vh - ${height} - 150px ) / 2 ) `;
      this.title=title||"预览文件";
    },
    onClose(){
      this.dialogVisible=false;
      this.src="";
      this._src="";
      this._download=undefined;
      this._fileinfo=null;
      this.title=null;
      this.top="15vh";

    },
    loadstart(){
      console.log("loadstart")
      this.load_win = this.$loading({
        target:document.querySelector(".view-file-win"),
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    loadeddata(){
      console.log("loadeddata")
      this.load_win.close();
    },
    downFile(){
      const that=this;
      that.down_loading=true;
      if(typeof this._download ==="function"){
        this._download()
      }else {
        window.open(this._src)
      }
      setTimeout(function () {
        that.down_loading=false;
      },5000)
    },
    openViewFile(){
      window.open(this.src);
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}
.view-file-win{
  position: relative;
  .view-file{
    border: 0;
    width: 100%;
    height: 600px;
  }
  .view-file-loading{

  }
}

>>>.el-dialog__body{
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/ViewFile.vue